// extracted by mini-css-extract-plugin
export default {"newsItem":"newsitem_newsItem__NEKX8"};